const RESOURCE_PARENT_IDS = {
  FIELD: 1,
  DISCOVERY: 2,
  PROSPECT: 3,
  HISTORIC: 4
};
Object.freeze(RESOURCE_PARENT_IDS);

const RESOURCE_STATUS_IDS = {
  HISTORIC_DISCOVERY: 20,
};
Object.freeze(RESOURCE_STATUS_IDS);

export { RESOURCE_PARENT_IDS, RESOURCE_STATUS_IDS };
